import { useState } from "react";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/common";

export default function AccountSecurity() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.new_password !== f.confirm) return setError("New passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      setF({ current_password: "", new_password: "", confirm: "" });
      toast.success("Password changed");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  const testEmail = async () => {
    try { const { data } = await api.post("/alerts/test-email"); data.ok ? toast.success("Test email sent to admin@therehablabsg.com") : toast.error(data.error); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Panel title="Account & alerts" icon={Lock} testid="account-security-panel">
      <form onSubmit={submit} className="grid gap-3 md:grid-cols-4" data-testid="change-password-form">
        <input data-testid="current-password-input" type="password" required placeholder="Current password" className="cc-input" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
        <input data-testid="new-password-input" type="password" required minLength={8} placeholder="New password (8+)" className="cc-input" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
        <input data-testid="confirm-password-input" type="password" required placeholder="Confirm new password" className="cc-input" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
        <button data-testid="change-password-button" disabled={busy} className="cc-btn cc-btn-primary">Change password</button>
      </form>
      {error && <div data-testid="change-password-error" className="mt-2 text-sm text-red-300">{error}</div>}
      <div className="mt-5 flex items-center justify-between gap-3 border-t border-[#1e293b] pt-4 text-sm text-slate-400">
        <span>Alert emails go to <span className="font-mono text-slate-200">admin@therehablabsg.com</span></span>
        <button data-testid="test-email-button" onClick={testEmail} className="cc-btn cc-btn-ghost px-3 py-1.5 text-xs"><Mail className="h-3.5 w-3.5" /> Send test email</button>
      </div>
    </Panel>
  );
}
